import { InsightProofIconButton } from '@modules/oracle/components/InsightProofIconButton';
import { useOracleSearchStore } from '@modules/oracle/store/oracleSearchStore';
import { ExtraProps } from 'react-markdown';

type FeedbackProofIconButtonProps = React.ClassAttributes<HTMLElement> &
  React.HTMLAttributes<HTMLElement> &
  ExtraProps & {
    sessionID: string;
    promptID: string;
  };

export function OracleInsightProofIconButton({
  node,
  children,
  sessionID,
  promptID,
}: FeedbackProofIconButtonProps) {
  const prompt = useOracleSearchStore(
    ({ data }) => data.promptByID?.[promptID],
  );

  const userQuoteTokenByResponseID = useOracleSearchStore(
    ({ data }) => data.userQuoteTokenByResponseID,
  );

  const artefactToken = node?.properties?.['id']
    ? prompt?.artefactDetailsByTokenID?.[String(node?.properties?.['id'])]
    : undefined;

  const exampleID = node?.properties?.['id']
    ? String(node?.properties?.['id'])
    : undefined;
  const feedbackSummaryExample = exampleID
    ? prompt?.feedbackSummaryExampleByID?.[exampleID]
    : undefined;
  const userQuotesByExampleID = prompt?.userQuoteByExampleID;
  const label = feedbackSummaryExample?.labelExample?.forLabel;

  return (
    <InsightProofIconButton
      feedbackSummaryExample={feedbackSummaryExample}
      userQuoteTokensByResponseID={userQuoteTokenByResponseID}
      userQuotesByExampleID={userQuotesByExampleID}
      sessionID={sessionID}
      label={label}
      children={children}
      artefact={artefactToken?.artefact}
    />
  );
}
